import cx from "classnames";
import parse from "html-react-parser";

// Components
import Button from "../Button/ButtonContainer";
import Section from "../Section/SectionContainer";

// CSS
import styles from "./block.module.scss";

const Block = (props) => {
    const {
        cta_link,
        cta_text,
        agenda_link,
        agenda_button_text,
        description,
        image,
        orientation,
        subtitle,
        title,
        style,
    } = props;

    /**
     * Constants
     */

    const buttonTheme = orientation === "Center" ? "" : "green";

    /**
     * End Hooks
     */

    return (
        <Section
            classes={cx(styles.block, {
                [styles["block--layout-center"]]: orientation === "Center",
                [styles["block--layout-left"]]: orientation === "Left",
                [styles["block--layout-right"]]: orientation === "Right",
            })}
            style={{ backgroundColor: style?.backgroundColor }}
        >
            <div
                className={styles.image}
                style={{ backgroundImage: `url(${image?.sizes?.large})` }}
            />
            <div className={styles.text} id="current_event">
                <h1 className={styles.header}>
                    {title && <span>{parse(props.title)}</span>}
                </h1>

                <span className={styles.subheader}>{subtitle}</span>

                <p className={styles.welcome_message}>
                    {description && <span>{parse(props.description)}</span>}
                </p>

                <span className={styles.btn_region}>
                    <a
                        href={cta_link}
                        rel="noreferrer"
                        target="_blank"
                        className={cx(styles.button, {
                            [styles["button--hidden"]]: !cta_link,
                        })}
                    >
                        <Button
                            classes={styles.button}
                            text={cta_text}
                            theme={buttonTheme}
                        />
                    </a>

                    <a
                        href={agenda_link}
                        rel="noreferrer"
                        className={cx(styles.button, {
                            [styles["button--hidden"]]: !agenda_link,
                        })}
                    >
                      <Button
                        classes={styles.button}
                        text={agenda_button_text}
                        theme={buttonTheme}
                      />
                    </a>
                </span>
            </div>
        </Section>
    );
};

export default Block;
